import DeliveryAssign from '../../components/deliveryCommon/DeliveryCommon';

const Express = () => {
	return (
		<DeliveryAssign deliveryType='express' title='Express Delivery Assign' />
	);
};

export default Express;
